// extracted by mini-css-extract-plugin
export default {"container":"product-header_container__zcLtY","sub-header-style":"product-header_sub-header-style__5b17d"};